import { TypedRoute, TypedRouteProps } from './typed-route'

export function PublicRoute(props: TypedRouteProps) {
  return <TypedRoute {...props} />
}
